"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomSlider = CustomSlider;
exports.yearSlider = void 0;

var _react = _interopRequireDefault(require("react"));

var _input = require("baseui/input");

var _UI = _interopRequireDefault(require("../UI"));

var _luxon = require("luxon");

var _geojsonutils = require("../../geojsonutils");

var _utils = require("../../utils");

var _slider = require("baseui/slider");

var _JSUtils = require("../../JSUtils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var yearSlider = function yearSlider(options) {
  var data = options.data,
      year = options.year,
      multiVarSelect = options.multiVarSelect,
      onSelectCallback = options.onSelectCallback,
      callback = options.callback;
  if (!data || !data.length || !Object.keys(data[0].properties)) return null;
  var yearColumn = (0, _utils.getFirstDateColumnName)(data[0].properties);
  if (!_luxon.DateTime.fromISO(data[0].properties[yearColumn]).isValid) return null;
  var years = (0, _geojsonutils.getPropertyValues)({
    features: data
  }, yearColumn).map(function (e) {
    return _luxon.DateTime.fromISO(e).year;
  }).sort();
  if (!years || !(0, _JSUtils.isArray)(years) || !years.length || years.length == 1) return null;
  return _react["default"].createElement(_UI["default"], {
    title: _react["default"].createElement("h5", null, "Year(s): ", year ? year : years[0] + " - " + years[years.length - 1], year && _react["default"].createElement("i", {
      style: {
        fontSize: '2rem'
      },
      className: "fa fa-trash",
      onClick: function onClick() {
        delete multiVarSelect[yearColumn];
        typeof onSelectCallback === 'function' && onSelectCallback(Object.keys(multiVarSelect).length === 0 ? {
          what: ''
        } : {
          what: 'multi',
          selected: multiVarSelect
        });
        callback({
          year: "",
          multiVarSelect: multiVarSelect
        });
      }
    })),
    sublist: _toConsumableArray(new Set(years)),
    suggested: "slider",
    onChange: function onChange(value) {
      multiVarSelect[yearColumn] = new Set([value + ""]);
      callback({
        year: value + "",
        multiVarSelect: multiVarSelect
      });
      typeof onSelectCallback === 'function' && onSelectCallback({
        selected: multiVarSelect,
        what: 'multi'
      });
    }
  });
};

exports.yearSlider = yearSlider;

function useInterval(callback, delay) {
  var savedCallback = _react["default"].useRef();

  _react["default"].useEffect(function () {
    savedCallback.current = callback;
  }, [callback]);

  _react["default"].useEffect(function () {
    function tick() {
      savedCallback.current();
    }

    if (delay !== null) {
      var id = setInterval(tick, delay);
      return function () {
        return clearInterval(id);
      };
    }
  }, [delay]);
}

function CustomSlider(props) {
  var s = '50',
      max = 5000,
      min = 100;

  var _React$useState = _react["default"].useState([0]),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      value = _React$useState2[0],
      setValue = _React$useState2[1];

  var _React$useState3 = _react["default"].useState([]),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      dates = _React$useState4[0],
      setDates = _React$useState4[1];

  var _React$useState5 = _react["default"].useState(null),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      delay = _React$useState6[0],
      setDelay = _React$useState6[1];

  var _React$useState7 = _react["default"].useState('1000'),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      amount = _React$useState8[0],
      setAmount = _React$useState8[1];

  _react["default"].useEffect(function () {
    setDates(props.dates);
    setValue(props.dates && [0]);
  }, [props]);

  useInterval(function () {
    setValue(function (prev) {
      return [(prev[0] + 1) % dates.length];
    });
    typeof callback === 'function' && callback(dates[value[0]]);
  }, delay);
  var callback = props.callback,
      data = props.data;
  if (!data || !data.length) return null;
  if (!dates) return null;
  return _react["default"].createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center'
    }
  }, _react["default"].createElement("div", {
    style: {
      maxWidth: 110
    }
  }, _react["default"].createElement(_input.Input, {
    value: amount,
    onChange: function onChange(e) {
      return setAmount(e.target.value);
    },
    placeholder: "Delay Input",
    type: "number",
    size: _input.SIZE.mini,
    clearable: true,
    clearOnEscape: true,
    min: min,
    max: max,
    step: s
  })), _react["default"].createElement("i", {
    style: {
      maxHeight: 40,
      maxWidth: 40
    },
    onClick: function onClick() {
      if (!delay) {
        setDelay(amount);
      } else {
        setDelay(null);
      }
    }
  }, !delay ? _react["default"].createElement("i", {
    style: {
      fontSize: '2em'
    },
    className: "fa fa-play"
  }) : _react["default"].createElement("i", {
    style: {
      fontSize: '2em'
    },
    className: "fa fa-pause"
  })), _react["default"].createElement("div", {
    style: {
      flexGrow: 1
    }
  }, _react["default"].createElement(_slider.Slider, {
    value: value,
    min: 0,
    max: props.dates.length - 1,
    step: 1,
    onChange: function onChange(params) {
      if (params.value) {
        setValue(params.value);
      } else {
        setValue([]);
      }

      if (delay) setDelay(null);
      typeof callback === 'function' && callback(dates[params.value]);
    },
    overrides: {
      ThumbValue: function ThumbValue(_ref) {
        var $value = _ref.$value;
        return _react["default"].createElement("div", {
          style: {
            position: 'absolute',
            top: -20,
            backgroundColor: 'transparent'
          }
        }, dates[$value]);
      },
      TickBar: function TickBar(_ref2) {
        var $min = _ref2.$min,
            $max = _ref2.$max;
        return _react["default"].createElement("div", {
          style: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }
        }, [dates[$min], dates[Math.floor($max / 2)], dates[$max]].map(function (e) {
          return _react["default"].createElement("div", {
            className: "slider-label",
            key: e
          }, e);
        }));
      }
    }
  })));
}